import { useSelector } from '@xstate/react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Tabs } from '~/components';
import { useAcademicsRef } from '../account/vaultSelectors';
import { ACADEMICS_TABS } from './tabs';

export const AcademicDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hashTab = location.hash.replace('#', '');

  const { academicsRef } = useAcademicsRef();
  if (!academicsRef) {
    return null;
  }
  const { currentTab } = useSelector(academicsRef, (state) => state.context);

  // Only navigate: the hash is the single source of truth and the effect
  // below syncs the machine from it. Sending ON_TAB_SWITCH here too creates
  // a render where the machine is ahead of the still-async router update,
  // which the effect would "correct" by bouncing back to the old tab.
  const handleTabChange = (index: number) => {
    navigate({ hash: index === 1 ? 'training' : 'education' }, { replace: true });
  };

  // No hash means the first tab: the machine outlives this page, so falling
  // back to its currentTab would resurrect the last-viewed tab when arriving
  // from the dashboard card (MCV-1464).
  const resolvedIndex = hashTab === 'training' ? 1 : 0;

  useEffect(() => {
    if (resolvedIndex !== currentTab) {
      academicsRef.send({ type: 'ON_TAB_SWITCH', value: resolvedIndex });
    }
  }, [academicsRef, currentTab, resolvedIndex]);

  const activeTab = ACADEMICS_TABS[resolvedIndex] ?? ACADEMICS_TABS[0];
  // This isn't wired into any machine, eventually LOADING and ACTOR could
  // be passed into the currentTab. See Profile for example.
  return (
    <>
      <div>
        <Tabs
          tabs={ACADEMICS_TABS}
          handleTabChange={handleTabChange}
          activeTab={ACADEMICS_TABS.findIndex((tab) => tab === activeTab)}
        />
        <activeTab.layout actor={academicsRef} />
      </div>
    </>
  );
};
